import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PDRObraAvaliacao'

const GetPDRFormEvaluation = (pdrObraId) => APIClient.get(`${APIPci}/${resourceName}/AvaliacaoFormularios/${pdrObraId}`)
const GetPDRMemberEvaluation = (pdrObraId, membroId) => APIClient.get(`${APIPci}/${resourceName}/AvaliacaoFormularioMembro/pdrobra/${pdrObraId}/membro/${membroId}`)
const PostPDRLotEvaluation = (pdrObraId, obj) => APIClient.post(`${APIPci}/${resourceName}/AvaliacaoEmLote/pdrobra/${pdrObraId}`, obj)
const PostLotEvaluationContract = (pdrObraId, obj) => APIClient.post(`${APIPci}/${resourceName}/AvaliacaoContratoEmLote/pdrobra/${pdrObraId}`, obj)
const GetPDRLotEvaluation = (pdrObraId) => APIClient.get(`${APIPci}/${resourceName}/AvaliacaoEmLote/pdrobra/${pdrObraId}`)
const PostPDREvaluation = (obj) => APIClient.post(`${APIPci}/${resourceName}`, obj)
const PostReprocDepartments = (pdrObraId) => APIClient.post(`${APIPci}/${resourceName}/reprocessa-departamentos/${pdrObraId}`)
const PostObservation = (obj) => APIClient.post(`${APIPci}/${resourceName}/observacao`, obj)
const GetLog = (id, config = {}) => APIClient.get(`${APIPci}/${resourceName}/log/${id}`, config)
const GetFormItem = (id, config = {}) => APIClient.get(`${APIPci}/${resourceName}/pdrformularioitem/${id}`, config)
const GetFinalEvaluation = (id, config = {}) => APIClient.get(`${APIPci}/${resourceName}/AvaliacaoFinal/${id}`, config)
const PostEvaluationEmail = (obj) => APIClient.post(`${APIPci}/${resourceName}/emailbonificacao`, obj)
const PostDepartamentEmailPendencies = () => APIClient.post(`${APIPci}/${resourceName}/emailpendenciasdepartamentos`)
const PostStartStoppage = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/InicioParalisacao/${id}`, obj)
const PostEndStoppage = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/TerminoParalisacao/${id}`, obj)
const PostMotiveStoppage = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/MotivoParalisacao/${id}`, obj)
const PostApproveTechnicalDirector = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/AprovarDiretorTecnico/${id}`)
const PostRepproveTechnicalDirector = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/ReprovarDiretorTecnico/${id}`, obj)
const PostRepproveEngineeringManager = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/ReprovarGerenteEngenharia/${id}`, obj)
const PostAdministrativeDirectorFinish = (obj) => APIClient.post(`${APIPci}/${resourceName}/TerminoDiretorAdministrativo`, obj)
const PostDocumentPendencies = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/DocumentacaoPendente/${id}`, obj)
const PrintFormularioAprovacao = (obj) => APIClient.post(`${APIPci}/${resourceName}/relatorio`, obj)
const DeleteAvaliacao = (id, obj) => APIClient.patch(`${APIPci}/${resourceName}/ExcluirAvaliacao/${id}`, obj)
const PostRequestForCreatePDC = (id, obj) => APIClient.post(`${APIPci}/${resourceName}/solicitarCriacaoPdc/${id}`, obj)
const GetPDRValues = (startDate, endDate, employee, companyid, option) => APIClient.get(`${APIPci}/${resourceName}/pdrvalores?inicio=${startDate}&fim=${endDate}&funcionario=${employee}&empresaid=${companyid}&opcao=${option}`)
const SetZeroAppraisalPDF = (obraid, obs, config = {}) => APIClient.post(`${APIPci}/${resourceName}/zerarAvaliacao/${obraid}`, obs, config)
const PrintFormularioAprovacaoPorObra = (id) => APIClient.get(`${APIPci}/${resourceName}/relatorio/obra/${id}`)

const PDRObraAvaliacaoRepository = {
  GetPDRFormEvaluation,
  GetPDRMemberEvaluation,
  GetPDRLotEvaluation,
  PostLotEvaluationContract,
  PostPDREvaluation,
  PostReprocDepartments,
  GetLog,
  GetFormItem,
  GetFinalEvaluation,
  PostEvaluationEmail,
  PostDepartamentEmailPendencies,
  PostStartStoppage,
  PostEndStoppage,
  PostMotiveStoppage,
  PostAdministrativeDirectorFinish,
  PostDocumentPendencies,
  PostPDRLotEvaluation,
  PostApproveTechnicalDirector,
  PostRepproveTechnicalDirector,
  DeleteAvaliacao,
  PostObservation,
  PrintFormularioAprovacao,
  PostRequestForCreatePDC,
  GetPDRValues,
  SetZeroAppraisalPDF,
  PrintFormularioAprovacaoPorObra,
  PostRepproveEngineeringManager
}

export default PDRObraAvaliacaoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdrobraavaliacao.js